module.exports = __webpack_public_path__ + "img/presse-olca.ff608ed2.jpg";